import {Locale} from '@aboutyou/config';
import {PhoneOS} from '@aboutyou/utils';
import React from 'react';
import styled from 'styled-components';
import {Icon} from '../../atoms/Icon/Icon';
import {StoreNames} from './assets';

interface Props {
  provider: PhoneOS;
  locale?: Locale;
  height?: number;
  className?: string;
}

// eslint-disable-next-line complexity
const getIconName = (locale: Locale, provider: PhoneOS): StoreNames => {
  const isIos = provider === 'ios';
  switch (locale) {
    case Locale.de_AT:
    case Locale.de_CH:
    case Locale.de_DE:
    case Locale.en_DE:
      return isIos ? StoreNames.AppStoreDe : StoreNames.PlayStoreDe;

    case Locale.fr_BE:
    case Locale.fr_CH:
      return isIos ? StoreNames.AppStoreFr : StoreNames.PlayStoreFr;

    case Locale.nl_BE:
    case Locale.nl_NL:
      return isIos ? StoreNames.AppStoreNl : StoreNames.PlayStoreNl;

    case Locale.ro_RO:
      return isIos ? StoreNames.AppStoreRo : StoreNames.PlayStoreRo;

    case Locale.sk_SK:
      return isIos ? StoreNames.AppStoreSk : StoreNames.PlayStoreSk;

    case Locale.pl_PL:
      return isIos ? StoreNames.AppStorePl : StoreNames.PlayStorePl;

    case Locale.cs_CZ:
      return isIos ? StoreNames.AppStoreCz : StoreNames.PlayStoreCz;
    default:
      return isIos ? StoreNames.AppStoreEn : StoreNames.PlayStoreEn;
  }
};

/**
 * Migrated this functionality from legacy code. This is sort of reusable component (wrapper)
 * around icons, so we don't need always find which App/Play store badge must be shown.
 */

export const StoreBadge: React.FC<Props> = ({
  provider,
  locale = Locale.en_ZZ,
  height = 30,
  className,
}) => {
  const asset = getIconName(locale, provider);
  return (
    <StyledIcon
      $aspectRatio={provider === 'ios' ? '3/1' : '3.375/1'}
      asset={asset}
      className={className}
      height={height}
    />
  );
};

const StyledIcon = styled(Icon)<{$aspectRatio: string}>`
  aspect-ratio: ${props => props.$aspectRatio};
`;
